module.exports = __webpack_public_path__ + "static/media/bo.c83fd441.svg";